(function() {
  'use strict';

  /*
    One viewer per page. Several homepage rows each load this file (the
    McDermott and Longoni tiles, the case tiles, Pool Ball Sets), and every
    copy used to run: its own modal, its own keydown and resize listeners.
    The first copy wins; it already re-scans on shopify:section:load, so a
    row that arrives later is picked up by it.
  */
  if (window.BCLongoniLightbox) return;

  var ROOT_SELECTOR = '#longoni-home-promo-section .longoni-promo-strip';
  var TRIGGER_SELECTOR = '[data-longoni-gallery-trigger]';
  var MIN_ZOOM = 1;
  var BUTTON_ZOOM = 2;
  var MAX_ZOOM = 3;
  var modal = null;
  var activeItems = [];
  /*
    A STATIC GALLERY (2026-09-23, the certificates page): a gallery whose
    items are documents, not products, says so with data-longoni-static on
    the gallery element. The viewer then shows no price and no ADD TO
    CART, keeps the title as plain text, preloads the neighbours of the
    frame it shows, and stands the item's thumbnail - blurred 2px - in the
    frame until the full-size file has decoded. Every product gallery is
    untouched: nothing here runs without the attribute.
  */
  var activeStatic = false;
  var activeIndex = 0;
  var angleIndex = 0;
  var lastTrigger = null;
  var lockedScrollY = 0;
  var touchStartX = null;
  var zoomLevel = MIN_ZOOM;
  var panX = 0;
  var panY = 0;
  var isPanning = false;
  var panStartX = 0;
  var panStartY = 0;
  var startPanX = 0;
  var startPanY = 0;
  var activePointers = [];
  var pinchStartDistance = 0;
  var pinchStartZoom = MIN_ZOOM;
  var didPan = false;
  var swapOffset = 0;
  var showImageToken = 0;
  var isClosing = false;
  var closeTimer = null;
  var focusableSelector = 'button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function createModal() {
    var node = document.createElement('div');
    node.className = 'longoni-lightbox';
    node.hidden = true;
    node.innerHTML = ''
      + '<div class="longoni-lightbox__backdrop" data-longoni-lightbox-close></div>'
      + '<div class="longoni-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Longoni product image viewer">'
      + '<button class="longoni-lightbox__close" type="button" aria-label="Close image viewer" data-longoni-lightbox-close>'
      + '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>'
      + '</button>'
      + '<div class="longoni-lightbox__media">'
      + '<button class="longoni-lightbox__previous" type="button" aria-label="Previous image" data-longoni-lightbox-previous>'
      + '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 18-6-6 6-6"/></svg>'
      + '</button>'
      + '<div class="longoni-lightbox__image-stage">'
      + '<div class="longoni-lightbox__image-viewport">'
      + '<img class="longoni-lightbox__image" alt="" draggable="false">'
      + '</div>'
      + '<div class="longoni-lightbox__stagebar">'
      + '<div class="longoni-lightbox__dots" data-longoni-dots hidden></div>'
      + '<div class="longoni-lightbox__zoomcapsule" data-longoni-zoomcapsule>'
      + '<button class="longoni-lightbox__zoomreset" type="button" aria-label="Reset zoom" data-longoni-zoomreset>1x</button>'
      + '<button class="longoni-lightbox__zoomstep" type="button" aria-label="Zoom out" data-longoni-zoomout>'
      + '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/><path d="M7.5 10.5h6"/></svg>'
      + '</button>'
      + '<input class="longoni-lightbox__zoomrange" type="range" min="1" max="3" step="0.05" value="1" aria-label="Zoom level" data-longoni-zoomrange>'
      + '<button class="longoni-lightbox__zoomstep" type="button" aria-label="Zoom in" data-longoni-zoomin>'
      + '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/><path d="M10.5 7.5v6M7.5 10.5h6"/></svg>'
      + '</button>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '<button class="longoni-lightbox__next" type="button" aria-label="Next image" data-longoni-lightbox-next>'
      + '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6"/></svg>'
      + '</button>'
      + '</div>'
      + '<div class="longoni-lightbox__details">'
      + '<a class="longoni-lightbox__title" href="#" aria-label="Open full product page"></a>'
      + '<div class="longoni-lightbox__price"></div>'
      + '<div class="longoni-lightbox__thumbnails" role="list" aria-label="Product options"></div>'
      + '<div class="longoni-lightbox__actions">'
      + '<button class="longoni-lightbox__desktop-add longoni-lightbox__cart-control product-card-atc" type="button" data-success-text="ADDED TO CART" aria-label="Add current Longoni product to cart">'
      + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/><line x1="12" y1="11" x2="12" y2="17"/><line x1="9" y1="14" x2="15" y2="14"/></svg>'
      + '<span class="longoni-lightbox__add-label" data-pca-label>ADD TO CART</span>'
      + '</button>'

      + '</div>'
      + '<p class="longoni-lightbox__error" hidden></p>'
      + '</div>'
      + '</div>';

    node.addEventListener('click', function(event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (didPan) {
        event.preventDefault();
        event.stopPropagation();
        didPan = false;
        return;
      }
      if (target && target.closest('[data-longoni-lightbox-close]')) {
        event.stopPropagation();
        closeModal();
      } else if (target && target.closest('[data-longoni-lightbox-previous]')) {
        // The controls own their taps outright: nothing about an arrow
        // press may travel on towards the photo's zoom machinery.
        event.preventDefault();
        event.stopPropagation();
        showAngle(angleIndex - 1);
      } else if (target && target.closest('[data-longoni-lightbox-next]')) {
        event.preventDefault();
        event.stopPropagation();
        showAngle(angleIndex + 1);
      } else if (target && target.closest('[data-longoni-angle-index]')) {
        showAngle(parseInt(target.closest('[data-longoni-angle-index]').getAttribute('data-longoni-angle-index'), 10));
      } else if (target && target.closest('[data-longoni-thumbnail-index]')) {
        showImage(parseInt(target.closest('[data-longoni-thumbnail-index]').getAttribute('data-longoni-thumbnail-index'), 10));
      } else if (target && target.closest('[data-longoni-zoomreset]')) {
        event.stopPropagation();
        resetZoom();
      } else if (target && target.closest('[data-longoni-zoomout]')) {
        event.stopPropagation();
        setZoom(zoomLevel - 0.5);
      } else if (target && target.closest('[data-longoni-zoomin]')) {
        event.stopPropagation();
        setZoom(zoomLevel + 0.5);
      } else if (target && target.closest('[data-longoni-zoomcapsule]')) {
        event.stopPropagation();
      }
    });

    // The capsule swallows its touches whole, so a tap or a slider drag
    // can never read as the stage's swipe gesture underneath it.
    var capsule = node.querySelector('[data-longoni-zoomcapsule]');
    if (capsule) {
      capsule.addEventListener('touchstart', function(event) { event.stopPropagation(); }, { passive: true });
      capsule.addEventListener('touchend', function(event) { event.stopPropagation(); }, { passive: true });
    }

    var stage = node.querySelector('.longoni-lightbox__image-stage');
    var viewport = node.querySelector('.longoni-lightbox__image-viewport');

    stage.addEventListener('touchstart', function(event) {
      if (zoomLevel > MIN_ZOOM) return;
      touchStartX = event.touches && event.touches.length ? event.touches[0].clientX : null;
    }, { passive: true });

    stage.addEventListener('touchend', function(event) {
      if (zoomLevel > MIN_ZOOM) return;
      if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
      var delta = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 42) return;
      showAngle(delta > 0 ? angleIndex - 1 : angleIndex + 1);
    }, { passive: true });

    viewport.addEventListener('dblclick', function(event) {
      event.preventDefault();
      if (zoomLevel > MIN_ZOOM) {
        resetZoom();
      } else {
        setZoom(BUTTON_ZOOM, event.clientX, event.clientY);
      }
    });

    // The wheel drives the zoom from 1x up, not only once the image is
    // already magnified and not only with ctrl held. The page behind is
    // scroll-locked while the viewer is open, so nothing is lost by
    // claiming the gesture here.
    viewport.addEventListener('wheel', function(event) {
      event.preventDefault();
      var nextZoom = zoomLevel + (event.deltaY < 0 ? 0.2 : -0.2);
      setZoom(nextZoom, event.clientX, event.clientY, true);
    }, { passive: false });

    // The slider zooms about the centre of the frame - there is no pointer
    // position to zoom around when the gesture happens off to the side.
    var range = node.querySelector('[data-longoni-zoomrange]');
    if (range) {
      range.addEventListener('input', function() {
        setZoom(parseFloat(range.value));
      });
      // Keep the arrows and swipes from reacting to keyboard use of the slider.
      range.addEventListener('keydown', function(event) {
        event.stopPropagation();
      });
    }

    viewport.addEventListener('pointerdown', handlePointerDown);
    viewport.addEventListener('pointermove', handlePointerMove);
    viewport.addEventListener('pointerup', handlePointerEnd);
    viewport.addEventListener('pointercancel', handlePointerEnd);
    viewport.addEventListener('lostpointercapture', handlePointerEnd);
    viewport.addEventListener('dragstart', function(event) {
      event.preventDefault();
    });

    document.body.appendChild(node);
    return node;
  }

  function parseProduct(item) {
    var raw = item.getAttribute('data-longoni-product');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  /*
    BUYABLE IS ONE RULE, AND IT COMES FROM THE DATA EVERY ROW ALREADY SHIPS.

    data-longoni-product carries variants[] with an available flag per
    variant - the McDermott tiles, the case tiles and the rubber row all
    render it from the same capture - so "can this be bought" is answered
    here once, for every row, without a handle or a row name in the code.

    No variants means no answer, and no answer is NOT sold out: a gallery
    item that fell back to its attributes carries an empty array, and
    greying its button would invent a stock state out of missing data.
  */
  function isBuyable(product) {
    if (!product || !product.variants || !product.variants.length) return true;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return true;
    }
    return false;
  }

  function getItems(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('.longoni-promo-strip__gallery-item')).map(function(item) {
      var title = item.getAttribute('data-longoni-title') || item.getAttribute('title') || 'Longoni product image';
      var product = parseProduct(item) || {
        title: title,
        handle: item.getAttribute('data-longoni-handle') || '',
        url: item.getAttribute('data-longoni-url') || item.getAttribute('href'),
        variants: []
      };
      var src = item.getAttribute('data-mfp-src') || item.getAttribute('href');
      var images = null;
      try {
        images = JSON.parse(item.getAttribute('data-longoni-images') || 'null');
      } catch (error) {
        images = null;
      }
      if (!images || !images.length) images = src ? [src] : [];
      return {
        src: src,
        images: images,
        label: item.getAttribute('data-longoni-label') || title,
        tileSrc: item.getAttribute('data-longoni-tile-src') || '',
        thumb: item.getAttribute('data-longoni-thumb') || item.getAttribute('data-mfp-src') || item.getAttribute('href'),
        alt: title,
        title: title,
        price: item.getAttribute('data-longoni-price') || '',
        url: item.getAttribute('data-longoni-url') || product.url || '#',
        handle: item.getAttribute('data-longoni-handle') || product.handle || '',
        product: product
      };
    }).filter(function(item) {
      return !!item.src;
    });
  }

  function renderThumbnails() {
    var thumbnails = modal.querySelector('.longoni-lightbox__thumbnails');
    thumbnails.innerHTML = '';
    // A single-product gallery (the case tiles) has no variants to offer,
    // so the strip disappears and the panel is title, price and ATC.
    thumbnails.hidden = activeItems.length < 2;
    if (thumbnails.hidden) return;
    activeItems.forEach(function(item, index) {
      var variant = document.createElement('div');
      variant.className = 'longoni-lightbox__variant';
      variant.setAttribute('role', 'listitem');

      // The strip greys and strikes an option that cannot be bought, the same
      // way the tile's own swatch does, and leaves it pressable: its
      // photographs are still worth looking at, and pressing it is what puts
      // the panel into the SOLD OUT state that explains itself.
      var buyable = isBuyable(item.product);
      if (!buyable) variant.className += ' is-sold-out';

      var button = document.createElement('button');
      button.className = 'longoni-lightbox__thumbnail' + (buyable ? '' : ' is-sold-out');
      button.type = 'button';
      button.setAttribute('aria-label', (buyable ? 'Select ' : 'Select (sold out) ') + (item.label || item.title));
      button.setAttribute('data-longoni-thumbnail-index', index);

      var image = document.createElement('img');
      image.src = item.thumb;
      image.alt = '';
      image.loading = 'lazy';
      button.appendChild(image);

      var label = document.createElement('span');
      label.className = 'longoni-lightbox__thumbnail-label';
      label.textContent = item.label || item.title;

      variant.appendChild(button);
      variant.appendChild(label);
      thumbnails.appendChild(variant);
    });
  }

  function openModal(galleryId, index, trigger) {
    var gallery = document.getElementById(galleryId);
    if (!gallery) return;

    activeItems = getItems(gallery);
    if (!activeItems.length) return;
    activeStatic = gallery.getAttribute('data-longoni-static') === 'true';

    modal = modal || createModal();
    modal.classList.toggle('is-static', activeStatic);
    var openingImage = modal.querySelector('.longoni-lightbox__image');
    if (openingImage) openingImage.classList.remove('is-placeholder');
    window.clearTimeout(closeTimer);
    isClosing = false;
    resetZoom();
    activeIndex = Math.max(0, Math.min(parseInt(index || 0, 10), activeItems.length - 1));
    lastTrigger = trigger || document.activeElement;
    lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    setViewportUnit();

    document.body.classList.add('longoni-lightbox-open');
    document.body.style.top = '-' + lockedScrollY + 'px';
    modal.hidden = false;
    if (prefersReducedMotion()) {
      modal.classList.add('is-open');
    } else {
      void modal.offsetWidth; // force reflow so the enter transition runs
      modal.classList.add('is-open');
    }
    renderThumbnails();
    /*
      Before the first frame is shown, so the panel is already at its final
      height when the dialog animates in - reserving it after would be a
      resize the viewer can see.
    */
    reserveTitleHeight();
    showImage(activeIndex);

    window.setTimeout(function() {
      var closeButton = modal.querySelector('.longoni-lightbox__close');
      if (closeButton) closeButton.focus();
    }, 0);
  }

  function closeModal() {
    if (!modal || modal.hidden || isClosing) return;
    resetZoom();
    modal.classList.remove('is-open');
    document.body.classList.remove('longoni-lightbox-open');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    if (prefersReducedMotion()) {
      modal.hidden = true;
      return;
    }
    isClosing = true;
    closeTimer = window.setTimeout(function() {
      modal.hidden = true;
      isClosing = false;
    }, 240);
  }

  function cleanPrice(value) {
    var container = document.createElement('div');
    container.innerHTML = value || '';
    return (container.textContent || container.innerText || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function updateDetails(item) {
    var title = modal.querySelector('.longoni-lightbox__title');
    var price = modal.querySelector('.longoni-lightbox__price');
    var addButtons = Array.prototype.slice.call(modal.querySelectorAll('.longoni-lightbox__cart-control'));
    var error = modal.querySelector('.longoni-lightbox__error');

    title.textContent = item.title;
    if (activeStatic) {
      // A document, not a product: the title names it and leads nowhere.
      title.removeAttribute('href');
      title.removeAttribute('aria-label');
    } else {
      title.href = item.url || '#';
      title.setAttribute('aria-label', 'Open full product page for ' + item.title);
    }
    price.textContent = cleanPrice(item.price);

    /*
      ADD TO CART becomes a grey, disabled SOLD OUT when the selected option
      has no variant left. Disabled rather than styled-and-inert: the click
      never reaches product-card-atc, so there is no silent no-op to explain,
      and the button says what happened instead of appearing to fail.

      The class is removed on every pass, not only added, because the same
      button serves every option in the strip - switching from a sold-out
      variant back to one in stock has to take the grey off again.
    */
    var buyable = isBuyable(item.product);
    addButtons.forEach(function(addButton) {
      var label = addButton.querySelector('[data-pca-label]');
      addButton.dataset.handle = item.handle || '';
      addButton.__pcaProduct = item.product;
      addButton.disabled = !buyable;
      addButton.classList.remove('pca--loading', 'pca--success');
      addButton.classList.toggle('is-sold-out', !buyable);
      if (buyable) {
        addButton.setAttribute('aria-label', 'Add ' + item.title + ' to cart');
        if (label) label.textContent = 'ADD TO CART';
      } else {
        addButton.setAttribute('aria-label', item.title + ' is sold out');
        if (label) label.textContent = 'SOLD OUT';
      }
    });

    error.hidden = true;
    error.textContent = '';
  }

  /*
    THE DIALOG DOES NOT CHANGE HEIGHT WHEN THE VARIANT CHANGES.

    Reported as the gallery resizing itself to each photo's aspect. It is
    not: measured on the draft at 375 across all five TP25A variants, the
    media box holds 366px, the stage 302, the viewport 279 and the photo
    279x279 in every one of them - the square aspect-ratio on
    .image-viewport (see the note beside it in the stylesheet) already
    pins that, and every frame in this catalogue is a 2048x2048 original
    anyway. The filmstrip row holds 78.9px, price 16.8, actions 44.2.

    What moved was the TITLE, and only by its own line height:

      Butt                          1 line   19.9px   details 201   dialog 567
      w/S2, S20, S30, Luna Nera     2 lines  37.9px   details 219   dialog 585

    18px of title is the whole 18px jump. So the fix is a reserve, not a
    cap: the title keeps the height of the LONGEST name among this
    product's own variants, so switching between them cannot move
    anything below it. It is per-product rather than a flat two-line rule,
    because a flat rule would pad every single-line product in the
    catalogue with a blank line it does not need.

    Measured on the real element, not a clone: swapping its text and
    reading back gives the exact box the browser will use, with the same
    width, font and wrapping. Nothing paints in between - the reads are in
    one synchronous pass and the original text is restored before the
    frame ends.

    THE HEIGHT COMES FROM getComputedStyle, NOT getBoundingClientRect, and
    that is not a style preference. This runs immediately after is-open is
    set, so the dialog is part-way through its enter transform, and a
    client rect is in screen space - it comes back multiplied by whatever
    scale the animation happens to be at. Measured: the two-line title
    read 37.92 through the rect while its real laid-out height was 39.5,
    a factor of exactly 0.96, so the reservation came out 1.5px short and
    left a 1.4px twitch behind - the whole bug in miniature, one order of
    magnitude down. Computed height is layout space and ignores ancestor
    transforms entirely.
  */
  function reserveTitleHeight() {
    if (!modal || modal.hidden) return;
    var dialog = modal.querySelector('.longoni-lightbox__dialog');
    var title = modal.querySelector('.longoni-lightbox__title');
    if (!dialog || !title) return;

    // Cleared first, or every pass would measure the last reservation.
    dialog.style.removeProperty('--longoni-title-reserve');
    if (activeItems.length < 2) return;

    var original = title.textContent;
    var tallest = 0;
    activeItems.forEach(function(item) {
      title.textContent = item.title || '';
      var height = parseFloat(window.getComputedStyle(title).height);
      if (height > tallest) tallest = height;
    });
    title.textContent = original;

    if (tallest > 0) {
      dialog.style.setProperty('--longoni-title-reserve', Math.ceil(tallest) + 'px');
    }
  }

  function updateThumbnails() {
    var activeThumb = null;
    Array.prototype.slice.call(modal.querySelectorAll('.longoni-lightbox__thumbnail')).forEach(function(thumbnail, index) {
      var isActive = index === activeIndex;
      thumbnail.classList.toggle('is-active', isActive);
      if (isActive) {
        thumbnail.setAttribute('aria-current', 'true');
        activeThumb = thumbnail;
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function currentImages() {
    var item = activeItems[activeIndex];
    if (!item) return [];
    return (item.images && item.images.length) ? item.images : [item.src];
  }

  function renderAngle() {
    var item = activeItems[activeIndex];
    var images = currentImages();
    var image = modal.querySelector('.longoni-lightbox__image');
    image.src = images[angleIndex] || item.src;
    image.alt = item.alt;
    // A static gallery keeps its arrows while it has more than one item.
    var hideArrows = activeStatic ? activeItems.length < 2 : images.length < 2;
    modal.querySelector('.longoni-lightbox__previous').hidden = hideArrows;
    modal.querySelector('.longoni-lightbox__next').hidden = hideArrows;

    var dots = modal.querySelector('[data-longoni-dots]');
    if (dots) updateDots(dots, images, hideArrows);
  }

  /*
    Dot indicators under the photo, one per frame of the current variant,
    on every band. They were the phone's stand-in for a column of 92px
    thumbnails down the left of the desktop dialog; that column went on
    2026-09-04 (its 106px track, its scrollbar and a lazy <img> per frame
    with it) and the photo took the width. The dots are buttons carrying
    data-longoni-angle-index, so the click handler at the top treats them
    exactly as it treated the thumbnails - showAngle(i) - and the arrows,
    the swipe and the keyboard are untouched.
  */
  function updateDots(dots, images, hide) {
    dots.hidden = hide;
    if (hide) return;
    if (dots.childElementCount !== images.length) {
      dots.innerHTML = '';
      for (var i = 0; i < images.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'longoni-lightbox__dot';
        dot.setAttribute('data-longoni-angle-index', String(i));
        dot.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + images.length);
        dots.appendChild(dot);
      }
    }
    for (var j = 0; j < dots.children.length; j++) {
      dots.children[j].classList.toggle('is-active', j === angleIndex);
    }
  }

  function showAngle(index) {
    if (!modal || !activeItems.length) return;
    var images = currentImages();
    // A static gallery's arrows, keys and swipe step through its ITEMS:
    // each document is one frame, so a step past it is the next document,
    // and showImage's decode gate carries the swap (see activeStatic).
    if (activeStatic && images.length < 2 && activeItems.length > 1) {
      showImage(activeIndex + (index > angleIndex ? 1 : -1));
      return;
    }
    if (images.length < 2) return;
    // An angle step supersedes any variant swap still waiting on decode -
    // a stale apply() landing afterwards would yank the view back to
    // frame 0 of the variant.
    showImageToken++;
    resetZoom();

    // Cross-fade rather than a hard src swap: the outgoing shot slides a
    // little the way it is heading and fades, the incoming one arrives the
    // same way. Direction comes from which side of the current index the
    // request lands on, so the arrows and the peek thumbnails both read
    // as movement rather than a flicker.
    var forward = index > angleIndex;
    var image = modal.querySelector('.longoni-lightbox__image');
    angleIndex = (index + images.length) % images.length;

    if (!image || prefersReducedMotion()) {
      renderAngle();
      return;
    }

    // The slide rides on swapOffset rather than a CSS class: applyZoomState
    // writes transform inline, and an inline transform beats any class, so
    // a class-based shift would simply never apply.
    image.classList.add('is-swapping');
    swapOffset = forward ? -28 : 28;
    applyZoomState(false);

    window.setTimeout(function() {
      renderAngle();
      swapOffset = forward ? 28 : -28;
      image.classList.add('is-dragging');   // suppress the transition for the jump across
      applyZoomState(false);
      image.classList.remove('is-dragging');
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
          swapOffset = 0;
          image.classList.remove('is-swapping');
          applyZoomState(false);
        });
      });
    }, 140);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function showImage(index) {
    if (!modal || !activeItems.length) return;
    activeIndex = (index + activeItems.length) % activeItems.length;
    angleIndex = 0;

    var image = modal.querySelector('.longoni-lightbox__image');
    var item = activeItems[activeIndex];
    var images = currentImages();
    var targetSrc = images[0] || item.src;
    var token = ++showImageToken;

    // Decode first, then swap everything in one synchronous pass with the
    // transition suppressed. Writing src before the file is ready is what
    // flickered on phones: iOS Safari blanks an <img> the moment its src
    // changes, so on a slow load the viewer flashed empty (and whatever
    // frames rapid taps left mid-flight) before the target arrived.
    // Desktop engines keep the old frame while loading, which is why the
    // bug never showed there. The token keeps rapid taps honest: only the
    // latest selection may apply, older decodes are discarded.
    var apply = function() {
      if (token !== showImageToken || !modal || modal.hidden) return;
      if (image) image.classList.add('is-dragging');
      resetZoom();
      renderAngle();
      if (image) image.classList.remove('is-placeholder');
      updateDetails(activeItems[activeIndex]);
      updateThumbnails();
      if (image) {
        void image.offsetWidth;
        image.classList.remove('is-dragging');
      }
      if (activeStatic) preloadNeighbours();
    };

    if (image && targetSrc && image.getAttribute('src') !== targetSrc) {
      // Whichever readiness signal lands first wins: complete for cached
      // frames, load/error for the network, decode() where it works. The
      // timer is not the mechanism - it is a relief valve for environments
      // where a deferred decode never settles, so the viewer can never be
      // starved into showing nothing at all.
      var applied = false;
      var applyOnce = function() {
        if (applied) return;
        applied = true;
        apply();
      };
      // A static gallery stands the item's small thumbnail in the frame,
      // blurred, while the full file decodes - decoded itself first, so
      // the frame never holds a file the browser has not finished with.
      var placeholderSrc = activeStatic && item.thumb && item.thumb !== targetSrc ? item.thumb : '';
      if (placeholderSrc) {
        var placed = false;
        var placeOnce = function() {
          if (placed || applied || token !== showImageToken || !modal || modal.hidden) return;
          placed = true;
          image.classList.add('is-placeholder');
          image.src = placeholderSrc;
        };
        var placeholder = new Image();
        placeholder.onload = placeOnce;
        placeholder.src = placeholderSrc;
        if (placeholder.complete) placeOnce();
      }
      var preload = new Image();
      preload.onload = applyOnce;
      preload.onerror = applyOnce;
      preload.src = targetSrc;
      if (preload.complete) {
        applyOnce();
      } else {
        if (preload.decode) preload.decode().then(applyOnce, function() {});
        // With a placeholder standing in the frame the valve has nothing
        // to rescue, and at 1200ms it wrote a 1MB original to the stage
        // while it was still downloading (measured at 3 Mbps: complete
        // false from 1230ms on). So it waits out a stalled request only.
        window.setTimeout(applyOnce, placeholderSrc ? 20000 : 1200);
      }
      return;
    }
    apply();
  }

  // The frames either side of the one on show, fetched and decoded ahead
  // so prev/next lands on a file that is already there. Static galleries
  // only (see activeStatic).
  function preloadNeighbours() {
    if (activeItems.length < 2) return;
    [-1, 1].forEach(function(offset) {
      var neighbour = activeItems[(activeIndex + offset + activeItems.length) % activeItems.length];
      if (!neighbour || !neighbour.src) return;
      var warm = new Image();
      warm.src = neighbour.src;
      if (warm.decode) warm.decode().catch(function() {});
    });
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function getZoomElements() {
    if (!modal) return null;
    return {
      viewport: modal.querySelector('.longoni-lightbox__image-viewport'),
      image: modal.querySelector('.longoni-lightbox__image'),
      capsule: modal.querySelector('[data-longoni-zoomcapsule]'),
      reset: modal.querySelector('[data-longoni-zoomreset]'),
      range: modal.querySelector('[data-longoni-zoomrange]')
    };
  }

  function getPanBounds(nextZoom) {
    var elements = getZoomElements();
    if (!elements) return { x: 0, y: 0 };
    var viewportWidth = elements.viewport.clientWidth;
    var viewportHeight = elements.viewport.clientHeight;
    var imageWidth = elements.image.offsetWidth * nextZoom;
    var imageHeight = elements.image.offsetHeight * nextZoom;
    return {
      x: Math.max(0, (imageWidth - viewportWidth) / 2),
      y: Math.max(0, (imageHeight - viewportHeight) / 2)
    };
  }

  function constrainPan() {
    var bounds = getPanBounds(zoomLevel);
    panX = clamp(panX, -bounds.x, bounds.x);
    panY = clamp(panY, -bounds.y, bounds.y);
  }

  function applyZoomState(isDragging) {
    var elements = getZoomElements();
    if (!elements) return;
    constrainPan();
    elements.image.style.transform = 'translate3d(' + (panX + swapOffset) + 'px, ' + panY + 'px, 0) scale(' + zoomLevel + ')';
    elements.image.classList.toggle('is-zoomed', zoomLevel > MIN_ZOOM);
    elements.image.classList.toggle('is-dragging', !!isDragging);
    elements.viewport.classList.toggle('is-zoomed', zoomLevel > MIN_ZOOM);
    elements.viewport.classList.toggle('is-dragging', !!isDragging);
    // The capsule wakes to full opacity while zoomed, and the 1x reset
    // fades in beside it only once there is something to reset.
    if (elements.capsule) elements.capsule.classList.toggle('is-zoomed', zoomLevel > MIN_ZOOM);
    if (elements.reset) elements.reset.classList.toggle('is-visible', zoomLevel > MIN_ZOOM);

    // The slider is a readout as much as a control: the wheel, pinch,
    // dblclick and the step buttons all end up here, so whatever moved the
    // zoom, the handle follows. Guarded against writing back into an input
    // the user is currently dragging, which would fight their pointer.
    if (elements.range && document.activeElement !== elements.range) {
      elements.range.value = String(zoomLevel);
    }
  }

  function setZoom(nextZoom, originX, originY, skipTransition) {
    var elements = getZoomElements();
    if (!elements) return;
    var previousZoom = zoomLevel;
    nextZoom = clamp(nextZoom, MIN_ZOOM, MAX_ZOOM);

    if (nextZoom === MIN_ZOOM) {
      zoomLevel = MIN_ZOOM;
      panX = 0;
      panY = 0;
      applyZoomState(false);
      return;
    }

    if (originX !== undefined && originY !== undefined && previousZoom !== nextZoom) {
      var rect = elements.viewport.getBoundingClientRect();
      var offsetX = originX - rect.left - rect.width / 2;
      var offsetY = originY - rect.top - rect.height / 2;
      var ratio = nextZoom / previousZoom;
      panX = panX * ratio - offsetX * (ratio - 1);
      panY = panY * ratio - offsetY * (ratio - 1);
    }

    zoomLevel = nextZoom;
    if (skipTransition) elements.image.classList.add('is-dragging');
    applyZoomState(false);
    if (skipTransition) elements.image.classList.remove('is-dragging');
  }

  function resetZoom() {
    zoomLevel = MIN_ZOOM;
    panX = 0;
    panY = 0;
    isPanning = false;
    activePointers = [];
    applyZoomState(false);
  }

  function updatePointer(event) {
    for (var i = 0; i < activePointers.length; i++) {
      if (activePointers[i].id === event.pointerId) {
        activePointers[i].x = event.clientX;
        activePointers[i].y = event.clientY;
        return;
      }
    }
  }

  function removePointer(event) {
    activePointers = activePointers.filter(function(pointer) {
      return pointer.id !== event.pointerId;
    });
  }

  function getPointerDistance() {
    if (activePointers.length < 2) return 0;
    var dx = activePointers[0].x - activePointers[1].x;
    var dy = activePointers[0].y - activePointers[1].y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function handlePointerDown(event) {
    var elements = getZoomElements();
    if (!elements) return;
    activePointers.push({ id: event.pointerId, x: event.clientX, y: event.clientY });

    if (activePointers.length === 2) {
      pinchStartDistance = getPointerDistance();
      pinchStartZoom = zoomLevel;
      event.preventDefault();
      return;
    }

    if (zoomLevel <= MIN_ZOOM) return;
    event.preventDefault();
    isPanning = true;
    didPan = false;
    panStartX = event.clientX;
    panStartY = event.clientY;
    startPanX = panX;
    startPanY = panY;
    elements.viewport.setPointerCapture(event.pointerId);
    applyZoomState(true);
  }

  function handlePointerMove(event) {
    updatePointer(event);

    if (activePointers.length >= 2 && pinchStartDistance > 0) {
      event.preventDefault();
      var distance = getPointerDistance();
      if (distance > 0) setZoom(pinchStartZoom * (distance / pinchStartDistance), event.clientX, event.clientY, true);
      return;
    }

    if (!isPanning || zoomLevel <= MIN_ZOOM) return;
    event.preventDefault();
    var deltaX = event.clientX - panStartX;
    var deltaY = event.clientY - panStartY;
    if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) didPan = true;
    panX = startPanX + deltaX;
    panY = startPanY + deltaY;
    applyZoomState(true);
  }

  function handlePointerEnd(event) {
    removePointer(event);
    if (activePointers.length < 2) pinchStartDistance = 0;
    if (!isPanning) return;
    isPanning = false;
    applyZoomState(false);
  }

  function trapFocus(event) {
    if (!modal || modal.hidden || event.key !== 'Tab') return;
    if (document.getElementById('pca-picker-overlay')) return;
    var focusable = Array.prototype.slice.call(modal.querySelectorAll(focusableSelector)).filter(function(element) {
      return element.offsetParent !== null && !element.disabled;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function handleKeydown(event) {
    if (!modal || modal.hidden) return;
    if (document.getElementById('pca-picker-overlay')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showAngle(angleIndex - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      showAngle(angleIndex + 1);
    } else {
      trapFocus(event);
    }
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  var bandMeasurements = {};
  var sameLineBand = window.matchMedia && window.matchMedia('(min-width: 1850px)');
  // The phone layout, where the band is anchored in px under the price.
  var phoneBand = window.matchMedia && window.matchMedia('(max-width: 749px)');
  // The reach the phone CSS anchor is cut for - see applyPhoneBandShift.
  var PHONE_BAND_REFERENCE_UP = 20;

  function measureBandExtent(imgEl) {
    // Reads the already-loaded chip <img> (crossorigin="anonymous" in markup) -
    // no image is ever fetched for measurement. Synchronous; caller ensures
    // imgEl.complete. Returns {up, height} in image-size fractions, or null.
    var key = imgEl.currentSrc || imgEl.src;
    if (Object.prototype.hasOwnProperty.call(bandMeasurements, key)) return bandMeasurements[key];
    var m = null;
    try {
      var n = 64;
      var canvas = document.createElement('canvas');
      canvas.width = n;
      canvas.height = n;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(imgEl, 0, 0, n, n);
      var data = ctx.getImageData(0, 0, n, n).data;
      var minDev = 2;
      var maxDev = -2;
      for (var y = 0; y < n; y++) {
        for (var x = 0; x < n; x++) {
          var i = (y * n + x) * 4;
          if ((data[i] + data[i + 1] + data[i + 2]) / 3 >= 245) continue;
          var dev = (x + y - n) / n;
          if (dev < -0.22) continue; // outside the diagonal clip band, mirrors the CSS clip-path
          if (dev < minDev) minDev = dev;
          if (dev > maxDev) maxDev = dev;
        }
      }
      if (maxDev >= minDev) {
        var up = Math.max(0, -minDev) / 1.4142;
        m = { up: up, height: up + Math.max(0, maxDev) / 1.4142 };
      }
    } catch (error) {
      m = null; // tainted canvas or decode failure: no fit data, band renders as before
    }
    bandMeasurements[key] = m;
    return m;
  }

  function bindPricePreview(tile) {
    var priceEl = tile.querySelector('.longoni-promo-strip__price');
    if (!priceEl) return;

    var eyebrowEl = priceEl.querySelector('.longoni-promo-strip__price-eyebrow');
    var figureEl = priceEl.querySelector('.longoni-promo-strip__price-figure');
    var originalParts = {
      eyebrow: eyebrowEl ? eyebrowEl.textContent : '',
      figure: figureEl ? figureEl.textContent : priceEl.textContent,
      figureHtml: figureEl ? figureEl.innerHTML : null
    };
    // The money filter wraps every price in <span class="hidePrice"> - the
    // wholesale app's price-hiding hook. No write may strip it: restores go
    // back through the captured markup, previews rebuild the wrapper.
    var figureKeepsHidePrice = !!(figureEl && figureEl.querySelector('.hidePrice'));
    var fromTemplate = tile.getAttribute('data-longoni-from-template') || '[PRICE]';
    var hoverCapable = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    var items = null;
    var swapTimer = null;
    var originalImage = tile.style.getPropertyValue('--longoni-image');
    var cta = tile.querySelector('.brand-promo__button.bc-buy') || tile.querySelector('.brand-promo__button');
    var soldOutEl = tile.querySelector('[data-longoni-soldout]');
    var originalCtaUrl = cta ? cta.getAttribute('href') : '';
    var imageTimer = null;
    var swapToken = 0;
    var preloaded = false;
    var previewRowsSelector = tile.getAttribute('data-longoni-preview-rows') || '';
    var previewRows = previewRowsSelector ? Array.prototype.slice.call(tile.querySelectorAll(previewRowsSelector)) : [];
    // data-src, not just src: a tile past the fourth in a rail row ships its
    // bands deferred (see assets/bc-tile-lazy.js), so at this point src is
    // null and reading only src would record "no image" as the default. The
    // first hover would then swap the band in and leaving would blank it.
    var defaultPreviewRows = previewRows.map(function(img) {
      if (img.style.visibility === 'hidden') return '';
      return img.getAttribute('src') || img.getAttribute('data-src') || '';
    });
    var defaultActiveThumb = tile.querySelector('.longoni-promo-strip__mini-button--thumb.is-active') || tile.querySelector('.longoni-promo-strip__mini-button--thumb');
    var previewRowsPreloaded = false;
    // A swatch names one source per band row: three on every pool, McDermott
    // and case tile, four on a carom tile, whose two-shaft sets show both
    // shafts. Never fewer than three, so a tile whose selector matches fewer
    // images still preloads and waits on exactly the sources it always did.
    var previewRowCount = Math.max(3, previewRows.length);
    function rowSourcesOf(thumb) {
      var sources = [];
      for (var r = 1; r <= previewRowCount; r++) sources.push(thumb.getAttribute('data-longoni-preview-row-' + r));
      return sources;
    }

    function applyPreviewRows(sources) {
      previewRows.forEach(function(img, index) {
        var source = sources[index] || '';
        img.style.visibility = source ? '' : 'hidden';
        if (source && img.getAttribute('src') !== source) img.setAttribute('src', source);
      });
    }

    function preloadPreviewRows() {
      if (!previewRows.length || previewRowsPreloaded) return;
      previewRowsPreloaded = true;
      Array.prototype.slice.call(tile.querySelectorAll('[data-longoni-preview-row-1]')).forEach(function(thumb) {
        rowSourcesOf(thumb).forEach(function(source) {
          if (!source) return;
          var image = new Image();
          image.src = source;
          if (image.decode) image.decode().catch(function() {});
        });
      });
    }

    /*
      Warm every variant's bands when the tile comes within 600px of the
      viewport, the same approach the rubber row uses.

      preloadPreviewRows already existed but only ran on the way INTO a
      preview, so the first swatch pressed on a tile paid the whole
      network cost inside the 400ms gate and swapped late however good the
      gate was. Warming on approach means the decode the gate waits for is
      already done, so the swap is immediate.

      Still nothing for a tile the reader never reaches: this is what the
      comment further down insists on, and an observer honours it where
      the old init-time preload did not.
    */
    if (previewRows.length && window.IntersectionObserver) {
      var warmObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          preloadPreviewRows();
          warmObserver.unobserve(entry.target);
        });
      }, { rootMargin: '600px 0px' });
      warmObserver.observe(tile);
    }

    function showPreviewRows(thumb) {
      preloadPreviewRows();
      setPreviewRows(rowSourcesOf(thumb));
    }

    function restorePreviewRows() {
      setPreviewRows(defaultPreviewRows);
    }

    function preloadTileImages() {
      if (preloaded) return;
      preloaded = true;
      getTileItems().forEach(function(item) {
        if (item.tileSrc) {
          var img = new Image();
          img.src = item.tileSrc;
        }
      });
    }

    var bandToken = 0;
    var originalFitImg;

    function clearBandFit() {
      tile.style.removeProperty('--longoni-band-scale');
      tile.style.removeProperty('--longoni-band-ty');
      tile.style.removeProperty('--longoni-band-shift');
    }

    /*
      Phones: the band's top is a fixed px anchor under the price, cut for
      the TALLER of the two photo shapes - a shaft variant shows butt and
      shaft together and reaches about 20px above the band's centre, where
      the single-cue default reaches about 7. Left alone, the default photo
      hangs 13px lower than it needs to, which is the air over the cue.

      So the difference is paid per photo rather than in both states: each
      photo is measured as it swaps in and the band shifts by how far its
      own reach differs from the 20px the CSS anchor assumes. The cue's TOP
      edge then lands in the same place whichever photo is showing, and the
      clearance under the digits is the same in both.

      A transform rather than the top, so it animates on the compositor and
      costs no layout; the transition lives with the rule in the section.
    */
    function applyPhoneBandShift(imgEl) {
      var m = imgEl ? measureBandExtent(imgEl) : null;
      if (!m || typeof m.up !== 'number') {
        tile.style.removeProperty('--longoni-band-shift');
        return;
      }
      // The band's side, read from the CSS rather than restated here: the
      // phone rule sets a different width from the desktop one (71 vs 74
      // per cent) and a copy of the number in this file would silently
      // drift from it. Falls back to the phone value if the pseudo cannot
      // be measured.
      var bandStyle = window.getComputedStyle(tile, '::before');
      var bandSide = bandStyle ? parseFloat(bandStyle.width) : NaN;
      if (!(bandSide > 0)) bandSide = 0.71 * tile.clientWidth;
      var reach = m.up * bandSide;
      tile.style.setProperty('--longoni-band-shift', (reach - PHONE_BAND_REFERENCE_UP).toFixed(1) + 'px');
    }

    function applyBandFit(imgEl) {
      bandToken++;
      var token = bandToken;
      if (phoneBand && phoneBand.matches) {
        tile.style.removeProperty('--longoni-band-scale');
        tile.style.removeProperty('--longoni-band-ty');
        if (!imgEl) { tile.style.removeProperty('--longoni-band-shift'); return; }
        var runPhone = function() {
          if (token !== bandToken) return;
          applyPhoneBandShift(imgEl);
        };
        if (imgEl.complete && imgEl.naturalWidth > 0) runPhone();
        else imgEl.addEventListener('load', runPhone, { once: true });
        return;
      }
      if (!imgEl || !sameLineBand || !sameLineBand.matches) { clearBandFit(); return; }
      var run = function() {
        if (token !== bandToken) return;
        var m = measureBandExtent(imgEl);
        if (!m || !m.height) { clearBandFit(); return; }
        var w = tile.clientWidth;
        var h = tile.clientHeight;
        var a = 0.74 * w;
        var zone = h - 125 - 66; // clearance line to button clearance; mirrors the same-line CSS constants
        var bandH = m.height * a;
        if (zone <= 0 || bandH <= zone) { clearBandFit(); return; }
        var s = zone / bandH;
        var ty = (125 + s * m.up * a) - (125 + 0.06 * w);
        tile.style.setProperty('--longoni-band-scale', s.toFixed(4));
        tile.style.setProperty('--longoni-band-ty', ty.toFixed(1) + 'px');
      };
      if (imgEl.complete && imgEl.naturalWidth > 0) {
        run(); // chip image already decoded: fit is set before the swapped band paints
      } else {
        imgEl.addEventListener('load', run, { once: true });
      }
    }

    function findOriginalFitImg() {
      if (originalFitImg !== undefined) return originalFitImg;
      originalFitImg = null;
      var urlMatch = (originalImage || '').match(/url\(['"]?([^'")]+)/);
      if (!urlMatch) return originalFitImg;
      var tileItems = getTileItems();
      var thumbEls = tile.querySelectorAll('.longoni-promo-strip__mini-button--thumb');
      for (var i = 0; i < thumbEls.length; i++) {
        var idx = parseInt(thumbEls[i].getAttribute('data-longoni-gallery-index') || '-1', 10);
        if (tileItems[idx] && tileItems[idx].tileSrc === urlMatch[1]) {
          originalFitImg = thumbEls[i].querySelector('img');
          break;
        }
      }
      return originalFitImg;
    }

    function setTileImage(value, fitImgEl) {
      if (!value) return;
      window.clearTimeout(imageTimer);
      if (tile.style.getPropertyValue('--longoni-image') === value) {
        tile.classList.remove('is-image-swapping');
        return;
      }
      // The fit is NOT applied here. It used to be, and that is the jump:
      // the shift is a property of the INCOMING photo, but the outgoing one
      // is still on screen for as long as the decode takes - measured on the
      // preview at 390, the shift moved at t=0 and the image only at t=120,
      // so for 120ms the old cue slid to where the new one belongs, over the
      // ::before's own 140ms transform transition. It now travels with the
      // pixels, inside the swap below, while the band is at opacity 0.
      if (prefersReducedMotion()) {
        applyBandFit(fitImgEl);
        tile.style.setProperty('--longoni-image', value);
        return;
      }
      // Decode the target before ever hiding the current frame: the old
      // blind 140ms timer flipped is-image-swapping (opacity:0 on the
      // diamond ::before) on a clock, with no guarantee the new
      // background-image had actually painted by then - on an uncached
      // swap the viewer saw the dark tile through the diamond's clip-path
      // notch for however long the paint actually took. Same
      // decode-then-swap shape as the lightbox's own showImage.
      var token = ++swapToken;
      var urlMatch = value.match(/url\(['"]?([^'")]+)/);
      var targetSrc = urlMatch ? urlMatch[1] : null;
      var startFade = function() {
        if (token !== swapToken) return;
        tile.classList.add('is-image-swapping');
        imageTimer = window.setTimeout(function() {
          if (token !== swapToken) return;
          // Geometry and pixels in one frame, both while the band is
          // invisible. is-image-swapping also drops the transform from the
          // ::before's transition list, so the shift lands as a jump rather
          // than as a slide - and the reflow below commits it while the
          // class is still on, so removing the class cannot start one
          // either: by then the transform already holds its new value.
          applyBandFit(fitImgEl);
          tile.style.setProperty('--longoni-image', value);
          void tile.offsetWidth;
          tile.classList.remove('is-image-swapping');
        }, 140);
      };
      if (!targetSrc) { startFade(); return; }
      var applied = false;
      var applyOnce = function() { if (applied) return; applied = true; startFade(); };
      var preload = new Image();
      preload.onload = applyOnce;
      preload.onerror = applyOnce;
      preload.src = targetSrc;
      if (preload.complete) {
        applyOnce();
      } else {
        if (preload.decode) preload.decode().then(applyOnce, function() {});
        window.setTimeout(applyOnce, 1200);
      }
    }

    function setPreviewRows(sources) {
      window.clearTimeout(imageTimer);
      var unchanged = previewRows.every(function(img, index) {
        var source = sources[index] || '';
        return img.getAttribute('src') === source && (img.style.visibility === 'hidden') === !source;
      });
      if (unchanged) {
        tile.classList.remove('is-image-swapping');
        return;
      }
      if (prefersReducedMotion()) {
        applyPreviewRows(sources);
        return;
      }
      // Same decode-then-swap shape as setTileImage above: this is
      // McDermott's three-row cue composite, heavier than Longoni's single
      // background-image swap, so it is the one most likely to still be
      // mid-decode when a fast hover-then-click opens the lightbox. Waiting
      // for every row to decode before fading keeps that decode work from
      // landing on top of (or racing) the modal's own image load.
      var token = ++swapToken;
      var targets = sources.filter(Boolean);
      var startFade = function() {
        if (token !== swapToken) return;
        tile.classList.add('is-image-swapping');
        imageTimer = window.setTimeout(function() {
          if (token !== swapToken) return;
          applyPreviewRows(sources);
          tile.classList.remove('is-image-swapping');
        }, 140);
      };
      if (!targets.length) { startFade(); return; }
      var remaining = targets.length;
      var settled = false;
      var oneRowReady = function() {
        remaining--;
        if (remaining <= 0 && !settled) { settled = true; startFade(); }
      };
      targets.forEach(function(src) {
        // Each row gets its own once-guard - onload/onerror and an
        // already-.complete image can both fire for the same load, and
        // without the guard that row would decrement remaining twice.
        var rowApplied = false;
        var rowApplyOnce = function() { if (rowApplied) return; rowApplied = true; oneRowReady(); };
        var preload = new Image();
        preload.onload = rowApplyOnce;
        preload.onerror = rowApplyOnce;
        preload.src = src;
        if (preload.complete) {
          rowApplyOnce();
        } else if (preload.decode) {
          preload.decode().then(rowApplyOnce, function() {});
        }
      });
      window.setTimeout(function() { if (!settled) { settled = true; startFade(); } }, 1200);
    }

    function getTileItems() {
      if (items) return items;
      var trigger = tile.querySelector('[data-longoni-gallery-trigger]');
      var gallery = trigger && document.getElementById(trigger.getAttribute('data-longoni-gallery-trigger'));
      items = gallery ? getItems(gallery) : [];
      return items;
    }

    function previewPartsFor(item, desc) {
      var variants = (item.product && item.product.variants) || [];
      var pool = variants.filter(function(v) { return v.available; });
      if (!pool.length) pool = variants;
      var distinct = {};
      pool.forEach(function(v) { distinct[v.price] = true; });
      var figure = Object.keys(distinct).length > 1
        ? fromTemplate.replace('[PRICE]', item.price)
        : item.price;
      /*
        THE EYEBROW IS THE PRICE'S LABEL, NEVER THE OPTION'S NAME
        (2026-09-28, the owner's brief). It used to be swapped for the
        swatch's own description, so a tile whose default option carried
        one showed it at rest: Black Mamba II read Luna Shaft above its
        price where every other tile read Starting from. The slot holds
        what the server rendered into it and nothing else; desc is still
        taken by the callers and is still what the swatch's aria and the
        lightbox read, it simply no longer lands here.
      */
      return { eyebrow: eyebrowEl ? eyebrowEl.textContent : '', figure: figure };
    }

    function applyPrice(parts) {
      if (eyebrowEl && figureEl) {
        eyebrowEl.textContent = parts.eyebrow;
        if (parts.figureHtml != null) {
          figureEl.innerHTML = parts.figureHtml;
        } else if (figureKeepsHidePrice) {
          figureEl.textContent = '';
          var hideSpan = document.createElement('span');
          hideSpan.className = 'hidePrice';
          hideSpan.textContent = parts.figure;
          figureEl.appendChild(hideSpan);
        } else {
          figureEl.textContent = parts.figure;
        }
      } else {
        priceEl.textContent = (parts.eyebrow ? parts.eyebrow + ' ' : '') + parts.figure;
      }
    }

    function priceMatches(parts) {
      if (eyebrowEl && figureEl) {
        return eyebrowEl.textContent === parts.eyebrow && figureEl.textContent === parts.figure;
      }
      return priceEl.textContent === (parts.eyebrow ? parts.eyebrow + ' ' : '') + parts.figure;
    }

    function setPriceParts(parts) {
      window.clearTimeout(swapTimer);
      if (priceMatches(parts)) {
        // The cancelled timer was the only thing that would have removed
        // the fade class - without this the price stays at opacity 0 after
        // a hover that leaves before the 140ms apply ever runs. Same
        // unchanged-branch cleanup setTileImage and setPreviewRows do.
        priceEl.classList.remove('is-swapping');
        return;
      }
      if (prefersReducedMotion()) {
        applyPrice(parts);
        return;
      }
      priceEl.classList.add('is-swapping');
      swapTimer = window.setTimeout(function() {
        applyPrice(parts);
        priceEl.classList.remove('is-swapping');
      }, 140);
    }

    function setActiveThumb(thumb) {
      var thumbs = tile.querySelectorAll('.longoni-promo-strip__mini-button--thumb');
      Array.prototype.forEach.call(thumbs, function(candidate) {
        var active = candidate === thumb;
        candidate.classList.toggle('is-active', active);
        if (active) candidate.setAttribute('aria-current', 'true');
        else candidate.removeAttribute('aria-current');
      });
      // Free-case bar follows the active option: shown only when that
      // option's product ships with a case (data-longoni-case set in Liquid).
      var caseBar = tile.querySelector('[data-longoni-case-bar]');
      if (caseBar && thumb) caseBar.hidden = !thumb.getAttribute('data-longoni-case');
      /*
        A swatch that sells the shaft ALONE marks the tile, and the rest is
        stylesheet: the butt rows fade to 0.28 and the FREE CASE bar goes
        out by visibility (a free case ships with a cue, not with a shaft).
        Toggled here rather than anywhere else because this runs inside
        commitPreviewState's single frame, so the fade, the bands, the
        price and the button all land together - and restore, which passes
        the default thumb through this same path, takes it back off.
      */
      if (thumb) tile.classList.toggle('is-shaft-only', thumb.getAttribute('data-longoni-shaft-only') === 'true');
    }

    /*
      BUY or SOLD OUT, decided by the option now selected.

      The item's variants are the source, so this is the same rule the panel
      uses and it needs nothing per row. data-longoni-available on the swatch
      is the fallback for the path with no gallery item to read - Liquid
      writes it from the option product's own availability - and if neither is
      there the tile keeps whichever state the server rendered.
    */
    function setBuyState(item, thumb) {
      if (!soldOutEl || !cta) return;
      var buyable;
      if (item && item.product) {
        buyable = isBuyable(item.product);
      } else if (thumb && thumb.hasAttribute('data-longoni-available')) {
        buyable = thumb.getAttribute('data-longoni-available') !== 'false';
      } else {
        return;
      }
      cta.hidden = !buyable;
      soldOutEl.hidden = buyable;
      /*
        AND THE BUTTON SAYS WHAT IT BUYS.

        Every tile ships "BUY <model>" in the markup, in two spans - the
        desktop one and the phone one - and a shaft swatch is the first
        option whose button must say something else: the link points at
        the shaft product, so the label has to as well ("BUY SHAFT").

        The server-rendered text is stashed on the span the first time it
        is touched, never read from a constant, so restore puts back
        whatever that tile actually had - including the stepped-down
        is-long variant and the Longoni row's short "BUY".
      */
      var buyLabel = thumb && thumb.getAttribute('data-longoni-buy-label');
      Array.prototype.forEach.call(cta.querySelectorAll('.longoni-promo-strip__button-label'), function (span) {
        if (span.getAttribute('data-longoni-label-default') === null) {
          span.setAttribute('data-longoni-label-default', span.textContent);
        }
        var next = buyLabel || span.getAttribute('data-longoni-label-default');
        if (span.textContent !== next) span.textContent = next;
      });
      /*
        AND THE CONFIG LINE SAYS WHAT IS SELECTED (2026-09-26, the Ambizione
        and Randers tiles). The same rule as the button's label above: the
        server-rendered text is stashed the first time it is touched, so a
        restore puts back whatever that tile actually had. A tile without the
        line - every carom tile that shipped before - has nothing to find and
        nothing happens.
      */
      var configEl = tile.querySelector('[data-longoni-config-line]');
      if (configEl) {
        if (configEl.getAttribute('data-longoni-config-default') === null) {
          configEl.setAttribute('data-longoni-config-default', configEl.textContent);
        }
        var configFromThumb = thumb && thumb.getAttribute('data-longoni-config');
        var configText = configFromThumb || configEl.getAttribute('data-longoni-config-default');
        if (configEl.textContent !== configText) configEl.textContent = configText;
      }
    }

    /*
      ONE STATE, ONE FRAME.

      showPreview used to set the swatch, the price and the button link
      straight away and only then hand the bands to setPreviewRows, which
      waits on decode and fades over 140ms. So a variant arrived in two
      instalments - label and price first, shaft and case after - which is
      the "appears separately" this replaces.

      Now nothing moves until every band of the TARGET state can be
      painted: they are decoded first, capped at 400ms so a cold image
      cannot hold the card (the cap the rubber row uses), and then the
      whole state - swatch, price, link, bands - is applied inside one
      requestAnimationFrame.

      swapToken is the race guard, shared with setPreviewRows: only the
      most recently requested state may apply, and a second click on the
      chip already in flight is not a new flight, so a fast series settles
      on the last one asked for rather than the last one to finish
      decoding.
    */
    var GATE_MS = 400;

    function commitPreviewState(thumb, item, sources) {
      var token = ++swapToken;
      var urls = (sources || []).filter(Boolean);
      var applied = false;

      if (!prefersReducedMotion()) tile.classList.add('is-image-swapping');

      var apply = function () {
        if (applied || token !== swapToken) return;
        applied = true;
        window.requestAnimationFrame(function () {
          if (token !== swapToken) return;
          setActiveThumb(thumb);
          if (item && item.price) {
            setPriceParts(previewPartsFor(item, thumb.getAttribute('data-longoni-eyebrow') || thumb.getAttribute('data-longoni-desc')));
          } else if (!item) {
            setPriceParts(originalParts);
          }
          if (cta) {
            var href = (item && item.url) ? item.url : originalCtaUrl;
            if (href) cta.setAttribute('href', href);
          }
          setBuyState(item, thumb);
          applyPreviewRows(sources);
          tile.classList.remove('is-image-swapping');
        });
      };

      if (!urls.length) { apply(); return; }

      var waits = urls.map(function (url) {
        return new Promise(function (resolve) {
          var image = new Image();
          image.src = url;
          if (image.decode) { image.decode().then(resolve, function () { resolve(); }); return; }
          if (image.complete) { resolve(); return; }
          image.onload = resolve;
          image.onerror = resolve;
        });
      });
      Promise.all(waits).then(apply, apply);
      // The ceiling. A band that is still on the network must not keep the
      // reader looking at the state they just left.
      window.setTimeout(apply, GATE_MS);
    }

    function showPreview(thumb) {
      var tileItems = getTileItems();
      if (!tileItems.length) return;
      var index = parseInt(thumb.getAttribute('data-longoni-gallery-index') || '0', 10);
      var item = tileItems[Math.max(0, Math.min(index, tileItems.length - 1))];
      if (!item) return;
      if (previewRows.length) {
        preloadPreviewRows();
        commitPreviewState(thumb, item, rowSourcesOf(thumb));
        return;
      }
      setActiveThumb(thumb);
      if (item.price) {
        setPriceParts(previewPartsFor(item, thumb.getAttribute('data-longoni-eyebrow') || thumb.getAttribute('data-longoni-desc')));
      }
      if (cta && item.url) cta.setAttribute('href', item.url);
      setBuyState(item, thumb);
      // No hover gate: on touch this same routine is what the first tap on
      // a swatch runs, and the preview has to swap there too.
      if (item.tileSrc) {
        preloadTileImages();
        setTileImage("url('" + item.tileSrc + "')", thumb.querySelector('img'));
      }
    }

    function restorePrice() {
      setPriceParts(originalParts);
      setTileImage(originalImage, findOriginalFitImg());
    }

    function restorePreview() {
      // Leaving is a state change like any other, so it goes through the
      // same gate: the default bands are decoded before the swatch, price
      // and link move back, and it takes the same token, so a hover that
      // leaves and returns cannot land out of order.
      if (previewRows.length) {
        commitPreviewState(defaultActiveThumb, null, defaultPreviewRows);
        setTileImage(originalImage, findOriginalFitImg());
        return;
      }
      if (defaultActiveThumb) setActiveThumb(defaultActiveThumb);
      if (cta && originalCtaUrl) cta.setAttribute('href', originalCtaUrl);
      setBuyState(null, defaultActiveThumb);
      restorePrice();
    }

    /*
      preloadPreviewRows() used to run right here, at tile init, for every
      tile on the page. It fetches each swatch's three band images through
      new Image(), and new Image() answers to nothing: not loading="lazy",
      not the viewport, not whether the tile is even on screen. So the
      McDermott section pulled every band of all thirteen tiles - both rows
      below the fold included, and every hover-only variant, the DEFY shaft
      and all three Vanquish wraps - about two seconds after load. Measured
      on the draft at 1280x720, scrolled to the top: 55 files, 1063KB.

      The swatch thumbnails in those same tiles are plain <img loading=
      "lazy"> and only four pairs of them loaded, which is the answer to
      whether native lazy copes with a horizontal rail: it does. The bands
      were not lazy-loading badly, they were not lazy-loading at all.

      showPreviewRows() calls this on the way into a preview, so the first
      hover on a tile still warms all three of its rows before the second
      swatch is tried. What is gone is paying for that on every tile in the
      section whether or not anyone points at it.
    */

    /*
      The band fit is otherwise only computed when a photo is swapped in,
      which leaves the state the card actually loads in - the default photo
      - unmeasured, and on phones that is the state whose shift matters
      most. findOriginalFitImg resolves the thumb whose image IS the
      default photo, so it is measured from the same already-decoded chip
      image as every other state.

      Re-run when the phone breakpoint is crossed: the shift is in px off a
      measurement in px, so it does not survive a width change on its own,
      and the desktop path wants the vars cleared rather than kept.
    */
    // The thumb whose image is the one the band is showing right now,
    // default or previewed - the same lookup findOriginalFitImg does, but
    // against the current value rather than the original.
    function currentFitImg() {
      var current = tile.style.getPropertyValue('--longoni-image') || originalImage;
      var urlMatch = (current || '').match(/url\(['"]?([^'")]+)/);
      if (!urlMatch) return findOriginalFitImg();
      var tileItems = getTileItems();
      var thumbEls = tile.querySelectorAll('.longoni-promo-strip__mini-button--thumb');
      for (var i = 0; i < thumbEls.length; i++) {
        var idx = parseInt(thumbEls[i].getAttribute('data-longoni-gallery-index') || '-1', 10);
        if (tileItems[idx] && tileItems[idx].tileSrc === urlMatch[1]) return thumbEls[i].querySelector('img');
      }
      return findOriginalFitImg();
    }

    applyBandFit(findOriginalFitImg());
    if (phoneBand) {
      var onPhoneBandChange = function() {
        applyBandFit(currentFitImg());
      };
      if (phoneBand.addEventListener) phoneBand.addEventListener('change', onPhoneBandChange);
      else if (phoneBand.addListener) phoneBand.addListener(onPhoneBandChange);
    }

    var thumbs = Array.prototype.slice.call(tile.querySelectorAll('.longoni-promo-strip__mini-button--thumb'));
    // The one revert (2026-09-24, the owner's rule for every card with
    // swatches): the pointer leaves the chip STRIP - pointerleave on
    // .longoni-promo-strip__actions, which holds every chip, the gaps
    // between them and the loupe. It was mouseleave on each chip, so the
    // gap between two chips put the default band back and the next chip
    // swapped it forward again - the flicker the owner reported on the
    // Longoni tiles, the same bug as the family cards' swatch gaps.
    var chipStrip = tile.querySelector('.longoni-promo-strip__actions');
    if (hoverCapable && chipStrip) chipStrip.addEventListener('pointerleave', restorePreview);
    thumbs.forEach(function(thumb) {
      if (hoverCapable) {
        thumb.addEventListener('mouseenter', function() { showPreview(thumb); });
      }
      // Tapping a link focuses it, same as tabbing to it does - unlike
      // mouseenter, focus was never gated to hoverCapable, so every touch
      // tap fired it as well as the delegated click handler's own
      // showPreview call below (touchOnly branch), and the leave-focus
      // that follows fired restorePreview in between: two full swap
      // cycles plus a revert racing for the same tap, the concrete cause
      // of the band photos re-switching several times before settling.
      // :focus-visible is the standard way to tell them apart - true for
      // real keyboard tabbing, false for the focus a pointer tap also
      // produces (same idiom this file already uses for the lightbox
      // controls' focus ring). Only keyboard focus drives the preview;
      // pointer taps are left entirely to the click handler.
      var focusWasVisible = false;
      thumb.addEventListener('focus', function() {
        try {
          focusWasVisible = !!(thumb.matches && thumb.matches(':focus-visible'));
        } catch (error) {
          // :focus-visible unsupported: fall back to the old always-on
          // behaviour rather than silently dropping keyboard preview.
          focusWasVisible = true;
        }
        if (focusWasVisible) showPreview(thumb);
      });
      thumb.addEventListener('blur', function() {
        if (focusWasVisible) restorePreview();
        focusWasVisible = false;
      });
    });

    // Touch translation of the hover mechanic: the gallery-trigger click
    // handler reads this to run the preview on the first tap of a swatch
    // and only open the viewer on a tap of the already-active one.
    tile.__longoniShowPreview = showPreview;
    // Read by the same click handler right before it opens the modal: a
    // hover fires on mouse-down-then-click before the click itself, so a
    // hover-then-click sequence can leave a decode still in flight when the
    // modal opens. Bumping the token here invalidates it - whichever
    // decode/timeout resolves later becomes a no-op - so the tile's own
    // preview swap never mutates DOM or decodes images on top of the
    // lightbox's own image load. This was the concrete cause of McDermott's
    // heavier three-row swap (setPreviewRows) stuttering the lightbox open
    // where Longoni's single background-image swap barely registered.
    tile.__longoniCancelPreview = function() {
      swapToken++;
      window.clearTimeout(imageTimer);
      // A cached image's decode can resolve synchronously, in the same
      // tick as the mouseenter that started it - startFade() then adds
      // is-image-swapping before this click handler ever runs, and
      // cancelling only the timer left the tile faded out with nothing
      // left to schedule its removal. Strip it here too so cancelling
      // always leaves the tile at full visibility, not mid-fade forever.
      tile.classList.remove('is-image-swapping');
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.longoniLightboxReady === 'true') return;
    root.dataset.longoniLightboxReady = 'true';

    Array.prototype.slice.call(root.querySelectorAll(TRIGGER_SELECTOR)).forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        // On touch there is no hover, so the swatch's two desktop roles
        // split across taps: the first tap on a not-yet-active swatch does
        // what hovering it does - swaps the tile preview - and a tap on
        // the active one opens the viewer, exactly like the desktop click.
        var touchOnly = !(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
        if (touchOnly &&
            trigger.classList.contains('longoni-promo-strip__mini-button--thumb') &&
            !trigger.classList.contains('is-active')) {
          var tile = trigger.closest('.longoni-promo-strip__tile');
          if (tile && tile.__longoniShowPreview) {
            tile.__longoniShowPreview(trigger);
            return;
          }
        }

        // A hover fires before this click on desktop; cancel whatever
        // preview swap it started so it can't decode/mutate images on top
        // of the modal that is about to open (see __longoniCancelPreview).
        var openingTile = trigger.closest('.longoni-promo-strip__tile');
        if (openingTile && openingTile.__longoniCancelPreview) openingTile.__longoniCancelPreview();

        /*
          THE LOUPE OPENS ON THE OPTION THE TILE IS SHOWING (2026-09-14).

          A swatch carries its own data-longoni-gallery-index; the loupe
          carries none, so it always opened on option 0 - on Lucky L1 with
          SHAFT ONLY chosen the viewer showed the whole cue, on Black Rainbow
          with Butt chosen the S20 set. The selected option is the swatch
          holding .is-active (setActiveThumb, above: the tapped one on touch,
          the default or the one still previewed on desktop), and its index
          is already the gallery's, so the viewer starts there with every
          option and every frame still in reach. No active swatch of this
          gallery (the case tiles have none) opens on the first, as before.
        */
        var galleryId = trigger.getAttribute('data-longoni-gallery-trigger');
        var startIndex = trigger.getAttribute('data-longoni-gallery-index');
        if (startIndex === null && openingTile) {
          var activeThumb = openingTile.querySelector('.longoni-promo-strip__mini-button--thumb.is-active[data-longoni-gallery-index]');
          if (activeThumb && activeThumb.getAttribute('data-longoni-gallery-trigger') === galleryId) {
            startIndex = activeThumb.getAttribute('data-longoni-gallery-index');
          }
        }
        /*
          The family cards (sections/chalk-cards.liquid with its loupe on -
          Cue Tip Tools) are not promo tiles: their selection is the active
          chip of the active tab's panel, and each chip carries its gallery
          position as data-bc-gallery-index. Same rule, other markup.
        */
        if (startIndex === null) {
          var familyCard = trigger.closest('[data-bc-gallery-scope]');
          var activeChip = familyCard && familyCard.querySelector('[data-simonis-size-panel].is-active [data-bc-gallery-index].is-active');
          if (activeChip) startIndex = activeChip.getAttribute('data-bc-gallery-index');
        }

        openModal(galleryId, startIndex || 0, trigger);
      });
    });

    Array.prototype.slice.call(root.querySelectorAll('.longoni-promo-strip__tile')).forEach(function(tile) {
      bindPricePreview(tile);
      tile.addEventListener('click', function(event) {
        var controlTarget = event.target && event.target.closest ? event.target.closest('[data-longoni-control], a, button') : null;
        if (controlTarget) return;
        var tileUrl = tile.getAttribute('data-longoni-tile-url');
        if (tileUrl) window.location.href = tileUrl;
      });
      tile.addEventListener('keydown', function(event) {
        var controlTarget = event.target && event.target.closest ? event.target.closest('[data-longoni-control], a, button') : null;
        if (controlTarget || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        var tileUrl = tile.getAttribute('data-longoni-tile-url');
        if (tileUrl) window.location.href = tileUrl;
      });
    });
  }

  function initAllRoots() {
    Array.prototype.slice.call(
      document.querySelectorAll(ROOT_SELECTOR + ', [data-mcdermott-tiles], [data-case-tiles], [data-bc-lightbox-root]')
    ).forEach(initRoot);
  }

  /*
    --bc-vh: one hundredth of the height the page can actually see, in px
    (2026-09-12). On iOS 100vh is the height with the address bar hidden, so
    a dialog sized in vh ran past the bottom of the screen and cut the photo
    whenever the bar was showing; dvh fixes that where it exists and is
    ignored where it does not. innerHeight is right in both, so the viewer
    sizes against calc(var(--bc-vh) * 100) with 1vh as the fallback.
  */
  function setViewportUnit() {
    var h = window.innerHeight || document.documentElement.clientHeight;
    if (h) document.documentElement.style.setProperty('--bc-vh', (h / 100) + 'px');
  }

  function init() {
    setViewportUnit();
    window.addEventListener('resize', setViewportUnit);
    window.addEventListener('orientationchange', setViewportUnit);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', setViewportUnit);
    initAllRoots();
    document.addEventListener('keydown', handleKeydown);
    /*
      The title reserve is a wrap measurement, so it belongs to the width it
      was taken at. Rotating a phone re-wraps the name and the reservation
      has to be retaken - debounced, and only while the dialog is actually
      open, so a page with no viewer open pays nothing.
    */
    var reserveTimer = 0;
    var retakeReserve = function() {
      if (!modal || modal.hidden) return;
      window.clearTimeout(reserveTimer);
      reserveTimer = window.setTimeout(reserveTitleHeight, 120);
    };
    window.addEventListener('resize', retakeReserve);
    window.addEventListener('orientationchange', retakeReserve);
    // The case rows arrive after the fact - fetched by their lazy slots,
    // which announce themselves with shopify:section:load. initRoot is
    // guarded by a dataset flag, so re-scanning is idempotent.
    document.addEventListener('shopify:section:load', initAllRoots);
    // A bfcache snapshot can be taken mid-fade (hover a swatch, then click
    // through before the 140ms apply): the snapshot keeps the fade class
    // but not the timer that removes it, so Back would restore the tile
    // with its price or image held invisible.
    window.addEventListener('pageshow', function(event) {
      if (!event.persisted) return;
      Array.prototype.slice.call(
        document.querySelectorAll('.longoni-promo-strip__price.is-swapping, .longoni-promo-strip__tile.is-image-swapping')
      ).forEach(function(el) {
        el.classList.remove('is-swapping');
        el.classList.remove('is-image-swapping');
      });
    });
  }

  /*
    The page-wide handle on this viewer: the guard at the top of the file
    reads it to keep a second copy from starting, and a script outside can
    open a gallery with it. Its first caller, the family-card loupe
    (chalk, balls, tips, gloves), was removed on 2026-09-15.
  */
  window.BCLongoniLightbox = { open: openModal };

  ready(init);
})();
/* sync touch 2026-09-28 */
